import React, { useEffect, useState, Suspense } from "react";
import { Button, Col, Form, Input, Row, notification, message, Switch, } from "antd";
import { Typography, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { customerService, emailService, dropdownService, countryService } from "../../../services";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import MaterialLikePasswordInput from "../../../components/MaterialLikeInputPassword";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";
import dayjs from "dayjs";
import { changeDocumentTitle } from "../../../utils/title";

const { Text } = Typography;

function CustomerForm() {

  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate()

  const isEditMode = id !== undefined;

  const [selectedEntities, setSelectedEntities] = useState([]);
  const [customer, setCustomer] = useState({});
  const [countries, setCountries] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [emailTypes, setEmailTypes] = useState([]);
  const [emailValues, setEmailValues] = useState({});
  const [sendEmailChecked, setSendEmailChecked] = useState(true);
  const [viewInvoiceChecked, setViewInvoiceChecked] = useState(true);
  const [agreementChecked, setAgreementChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  // const [vehicle_col, setVehicle_col] = useState([]);

  // for confirm password validation
  const [password, setPassword] = useState(false)

  // const handleSelectChange = (value) => {
  //   setSelectedEntities(value);
  // };

  // const calculateWidth = (dataLength) => {
  //   const baseWidth = 400;
  //   const additionalWidth = dataLength * 20;
  //   return baseWidth + additionalWidth;
  // };

  const handleEmailChange = (typeId, value) => {
    setEmailValues((prev) => ({
      ...prev,
      [typeId]: value,
    }));
  };

  const onFinish = async (values) => {
    setLoading(true)
    const emailTypeIds = emailTypes.map((emailType) => emailType.id.toString());
    const emailTypeValues = emailTypes.map((emailType) => emailValues[emailType.id] || "");
    const checkboxStates = {
      send_email: sendEmailChecked ? 1 : 0,
      view_invoice: viewInvoiceChecked ? 1 : 0,
      is_agreement_required: agreementChecked ? 1 : 0,
    };

    const data = {
      ...values,
      contract_start_date: dayjs(values.contract_start_date).format(
        "YYYY-MM-DD"
      ),
      contract_end_date: dayjs(values.contract_end_date).format("YYYY-MM-DD"),
      columns_view: selectedEntities,
      email_type: emailTypeIds,
      email_values: emailTypeValues,
      ...checkboxStates,
    };
    const response = isEditMode ? await customerService.editCustomer(id, data) : await customerService.addCustomer(data);
    setLoading(false)
    if (response?.success ?? false) {
      notification.success({ message: "Success", description: `Customer ${isEditMode ? 'updated' : 'added '}  successfully!`, placement: "topRight" });
      setPassword(false)
      navigate(`/operations/customer`)
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Error Info: ' + errorInfo)
  }

  const loadParentCustomers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };

  const loadCountries = async () => {
    const { success, data } = await countryService.countryGet();
    if (success) {
      setTimeout(() => {
        setCountries(data);
        setLoading(false);
      }, 2000);
    }
  };

  // const loadVehicleColumns = async () => {

  //   const { success, data: vehicleData, message: vehicleMessage } = await vehicleService.getColumns();
  //   if (success) {
  //     setVehicle_col(vehicleData);
  //     setSelectedEntities(vehicleData);
  //   } else {
  //     console.error(
  //       `Error fetching vehicle columns: ${vehicleMessage || "Unknown error"}`
  //     );
  //   }
  // }

  const loadEmails = async () => {
    const { success: emailSuccess, data: emailData, message: emailMessage } = await emailService.fetch();
    if (emailSuccess) {
      setEmailTypes(emailData);
      const initialInputs = {};
      emailData.forEach((type) => {
        initialInputs[type.id] = "";
      });
      setEmailValues(initialInputs);
    } else {
      console.error(
        `Error fetching email types: ${emailMessage || "Unknown error"}`
      );
    }
  }

  const loadData = async () => {
    const hide = message.loading("Fetching Data...", 0)
    const { success: customerSuccess, data: cusData } = await customerService.view(id);
    hide()
    if (customerSuccess) {
      setCustomer(cusData.customer);
      setSendEmailChecked(cusData.customer.send_email);
      setViewInvoiceChecked(cusData.customer.view_invoice);
      setAgreementChecked(cusData.customer.is_agreement_required);
      setSelectedEntities(cusData.customer.columns_view);

      form.setFieldsValue({
        ...cusData.customer,
        parent_id: cusData.customer.parent_id > 0 ? cusData.customer.parent_id : null,
        contract_start_date: cusData.customer.contract_start_date
          ? dayjs(cusData.customer.contract_start_date)
          : null,
        contract_end_date: cusData.customer.contract_end_date
          ? dayjs(cusData.customer.contract_end_date)
          : null,
      });

      const updatedEmailValues = { ...emailValues };
      cusData?.customer.user_email_types?.forEach((emailType) => {
        updatedEmailValues[emailType.email_type_id] = emailType.email || "";
      });
      setEmailValues(updatedEmailValues);
    }

  };

  useEffect(() => {
    // Update emailValues once both emailTypes and customer data are loaded
    if (emailTypes.length > 0 && customer.user_email_types) {
      const updatedEmailValues = { ...emailValues };
      customer.user_email_types.forEach((emailType) => {
        updatedEmailValues[emailType.email_type_id] = emailType.email || "";
      });
      setEmailValues(updatedEmailValues);
    }
  }, [customer]);

  useEffect(() => {
    changeDocumentTitle(isEditMode ? "Edit Customer" : "Add Customer");
    loadEmails()
    // loadVehicleColumns()
    if (isEditMode) {
      loadData();
    }
    loadParentCustomers();
    loadCountries()
  }, []);

  return (
    <div style={{ padding: "0 14px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }} >
      <Row
        gutter={26}
        style={{
          backgroundColor: "#FBFBFB",
          marginBottom: 15,
          padding: "10px",
          borderRadius: "4px",
          borderBottom: "1px solid #E8E8E9",
        }}
      >
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }}>
            {isEditMode ? "Edit Customer" : "Add Customer"}
          </h1>
        </Col>
      </Row>

      <Form form={form} layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item name="name" rules={[{ required: true, message: "Please input name!" }]}>
              <MaterialLikeInput
                label="Name"
                required
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="email"
              rules={[
                { required: true, message: "Please input email!" },
                {
                  type: "email",
                  message: "Please enter a valid email!",
                },
              ]}
            >
              <MaterialLikeInput
                label="Email"
                required
                autoComplete="new-password"
                name="fake-email"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="password"
              rules={[{ required: !isEditMode, message: "Please input password!" }]}
              onChange={() => setPassword(!!form.getFieldValue('password'))}
            >
              <MaterialLikePasswordInput
                label="Password"
                required={!isEditMode}
                autoComplete="new-password"
                name="fake-email"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="password_confirmation"
              dependencies={["password"]}
              rules={[
                {
                  required: password,
                  message: "Please input confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords do not match!")
                    );
                  },
                })
              ]}
            >
              <MaterialLikePasswordInput
                label="Confirm Password"
                required={!isEditMode}
                value={form.getFieldValue("password_confirmation")}
                onChange={(e) => form.setFieldValue("password_confirmation", e.target.value)}
              />
            </Form.Item>
          </Col>

          {/* Other fields */}
          <Col span={6}>
            <Form.Item name="address"
            // rules={[{ required: true, message: "Please input address!" }]}
            >
              <MaterialLikeInput
                label="Address"
                // required
                value={form.getFieldValue("address")}
                onChange={(e) => form.setFieldValue("address", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="town"
            // rules={[{ required: true, message: "Please input town!" }]}
            >
              <MaterialLikeInput
                label="Town"
                // required
                value={form.getFieldValue("town")}
                onChange={(e) => form.setFieldValue("town", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="city"
            // rules={[{ required: true, message: "Please input city!" }]}
            >
              <MaterialLikeInput
                label="City"
                // required
                value={form.getFieldValue("city")}
                onChange={(e) => form.setFieldValue("city", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="country"
            // rules={[{ required: true, message: "Please select a country!" }]}
            >
              <MaterialLikeSelect
                label="Country"
                // required
                value={form.getFieldValue("country")}
                onChange={(value) => form.setFieldValue('country', value)}
                options={countries.map((country) => ({
                  id: country.id,
                  value: country.iso_code,
                  label: country.name,
                }))}
              />
              {/* <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                dropdownRender={(menu) => {
                  if (loading) {
                    return (
                      <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                        <Spin size="small" />
                      </div>
                    );
                  }
                  return menu;
                }}
              >
                {countries.map((country) => (
                  <Select.Option key={country.id} value={country.iso_code} >
                    {country.name}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="phone"
            // rules={[{ required: true, message: "Please input phone number!" }]}
            >
              <MaterialLikeInput
                label="Phone"
                // required
                value={form.getFieldValue("phone")}
                onChange={(e) => form.setFieldValue("phone", e.target.value)}
                type="number"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="secondary_email">
              <MaterialLikeInput
                label="Secondary Email"
                value={form.getFieldValue("secondary_email")}
                onChange={(e) => form.setFieldValue("secondary_email", e.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="parent_id"
            >
              <MaterialLikeSelect
                label="Parent Customer"
                // required
                value={form.getFieldValue("parent_id")}
                onChange={(value) => form.setFieldValue('parent_id', value)}
                options={customers.map((cust) => ({
                  id: cust.id,
                  value: cust.id,
                  label: cust.name,
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="contract_start_date">
              <MaterialLikeDatePicker
                label="Contact Start"
                value={form.getFieldValue("contract_start_date")}
                onChange={(date) => form.setFieldValue("contract_start_date", date)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="contract_end_date">
              <MaterialLikeDatePicker
                label="Contact End"
                value={form.getFieldValue("contract_end_date")}
                onChange={(date) => form.setFieldValue("contract_end_date", date)}
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="contract_days">
              <MaterialLikeInput
                label="Contract Days"
                value={form.getFieldValue("contract_days")}
                onChange={(e) => form.setFieldValue("contract_days", e.target.value)}
                type="number"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="contract_charges">
              <MaterialLikeInput
                label="Contact Charges/day"
                value={form.getFieldValue("contract_charges")}
                onChange={(e) => form.setFieldValue("contract_charges", e.target.value)}
                type="number"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item name="file_ref">
              <MaterialLikeInput
                label="File Reference Number"
                readOnly={!!customer.file_ref}
              />
            </Form.Item>
          </Col>

          {/* <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: calculateWidth(vehicle_col.length), margin: "30px" }}>
              <Form.Item
                label={<Title level={5}>Vehicle Columns</Title>}
              >
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Select vehicle columns"
                  value={selectedEntities}
                  onChange={handleSelectChange}
                >
                  {vehicle_col.map((entity, index) => (
                    <Option key={index} value={entity}>
                      {entity}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </Col> */}
        </Row>
      </Form>

      {/* Email and Agreement Section */}
      <div
        style={{
          margin: "40px",
          padding: "0 14px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
          marginTop: "20px",
          paddingBottom: 20,
        }}
      >
        <Suspense fallback={<Spin />}>
          <Row gutter={24}>
            <Col
              span={24}
              style={{
                paddingBottom: 10,
                paddingTop: 10,
                borderBottom: "1px solid #E8E8E9",
                backgroundColor: "#FBFBFB",
              }}
            >
              <Row style={{ backgroundColor: "#FBFBFB" }}>
                <Col span={6}>
                  <h3 style={{ fontWeight: "bold" }}>Email</h3>
                </Col>
                <Col span={18}>
                  <p style={{ fontWeight: "bold" }}>
                    Emails (use comma to add multiple email IDs)
                  </p>
                </Col>
              </Row>
            </Col>

            {emailTypes.map((emailItem, index) => (
              <Col
                key={emailItem.id}
                span={24}
                style={{
                  paddingBottom: 10,
                  borderBottom: "1px solid #E8E8E9",
                  backgroundColor: index % 2 === 0 ? "#F2F2F7" : "#F4F7FE",
                  paddingTop: 10,
                }}
              >
                <Row>
                  <Col span={6}>
                    <h4 style={{ margin: 0 }}>{emailItem.name} Emails</h4>
                  </Col>
                  <Col span={18}>
                    <Input
                      placeholder={`Enter ${emailItem.name} Email`}
                      key={
                        customer?.user_email_types?.find(
                          (email) => email.email_type_id === emailItem.id
                        )?.email || ""
                      }
                      defaultValue={
                        customer?.user_email_types?.find(
                          (email) => email.email_type_id === emailItem.id
                        )?.email || ""
                      }
                      onChange={(e) =>
                        handleEmailChange(emailItem.id, e.target.value)
                      }
                    />
                  </Col>
                </Row>
              </Col>
            ))}

            {/* Checkbox Section */}
            <Col span={24} className="text-center my-5">
              <Text>Agreement</Text>
              <br />
              <Switch
                checked={agreementChecked}
                onChange={(checked) => setAgreementChecked(checked)}
              />
            </Col>

            {/* <Col span={24} style={{ marginBottom: "20px" }}>
            <Row>
              <Col span={24} className="flex flex-row justify-around mt-5">
                <Checkbox
                  checked={sendEmailChecked}
                  style={{ marginRight: "20px" }}
                  onChange={(e) => setSendEmailChecked(e.target.checked)}
                >
                  Send Email
                </Checkbox>
                <Checkbox
                  checked={viewInvoiceChecked}
                  style={{ marginRight: "20px" }}
                  onChange={(e) => setViewInvoiceChecked(e.target.checked)}
                >
                  View Invoice
                </Checkbox>

              </Col>
            </Row>
          </Col> */}

            {/* Add Customer Button */}
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                style={{ width: "50%" }}
                loading={loading}
                // htmlType="submit"
                onClick={() => form.submit()}
              >
                {isEditMode ? "Update Customer" : "Add Customer"}
              </Button>
            </Col>
          </Row>
        </Suspense>
      </div>
    </div >
  );
}

export default CustomerForm;